// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"31026ab2","237":"a720c829","272":"82cba2d9","319":"da221a62","354":"9535778d","435":"9d9befb4","507":"885366b2","787":"28cb0dcd","836":"b961123b","975":"c0577c47"}[chunkId] + ".chunk.js";
};